import { BaseWithId } from '@app/shared/models/base';

export class Banner extends BaseWithId {
    public content: string;
    public width: string;
    public height: string;

    constructor(json?: any) {
        super(json);
    }
}
